/* eslint-disable @next/next/no-img-element */
import { useAmp } from 'next/amp';
import React, { useState } from 'react';
import Container from '../../atoms/Container';
import Style from './ArticleReview.css';

function ArticleReview({ slug }) {
  const stateKey = `review-${slug}`.replace(/-/gi, '');
  const isAmp = useAmp();
  const [pressed, setPressed] = useState(null);

  const handlePress = (value) => {
    if (value === pressed) {
      setPressed(null);
    } else {
      setPressed(value);
    }
  };

  return (
    <>
      <Container extraPadding className="article-review">
        <h2>Esse artigo foi útil?</h2>
        <div className="review-btns">
          <button
            id={`review-btn-like`}
            on={`tap:AMP.setState({${stateKey}: 1})`}
            data-amp-bind-class={`${stateKey} == 1 ? 'pressed': ''`}
            className={pressed === 1 ? 'pressed' : ''}
            onClick={() => {
              handlePress(1);
            }}
          >
            {isAmp && (
              <amp-img
                src="../static/amp/shared/assets/ic_functional_like.svg"
                alt="Ícone de like"
                width="20"
                height="20"
              />
            )}

            {!isAmp && (
              <img
                src="../static/amp/shared/assets/ic_functional_like.svg"
                alt="Ícone de like"
                width="20"
                height="20"
              />
            )}
          </button>
          <button
            id={`review-btn-dislike`}
            on={`tap:AMP.setState({${stateKey}: 0})`}
            data-amp-bind-class={`${stateKey} == 0 ? 'pressed': ''`}
            className={pressed === 0 ? 'pressed' : ''}
            onClick={() => {
              handlePress(0);
            }}
          >
            {isAmp && (
              <amp-img
                src="../static/amp/shared/assets/ic_functional_dislike.svg"
                alt="Ícone de dislike"
                width="20"
                height="20"
              />
            )}

            {!isAmp && (
              <img
                src="../static/amp/shared/assets/ic_functional_dislike.svg"
                alt="Ícone de dislike"
                width="20"
                height="20"
              />
            )}
          </button>
        </div>
      </Container>
      <style jsx>{Style}</style>
    </>
  );
}

export default ArticleReview;
